import { render, staticRenderFns } from "./FilterPills.vue?vue&type=template&id=279cc6ac&"
import script from "./FilterPills.vue?vue&type=script&lang=js&"
export * from "./FilterPills.vue?vue&type=script&lang=js&"
import style0 from "./FilterPills.vue?vue&type=style&index=0&id=279cc6ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports